import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import axAPI from "../../../api/axios-instance";
import { DataProvider } from "@refinedev/core";
import { ClubManagementCreateRequest } from "../Lib/types";

export const lawyerManagementDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    getList: async ({ resource, sort, meta }) => {
      try {
        const { data: response } = await httpClient.get("/cms/league/lawyer");
        return {
          data: [response],
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    getOne: async ({ resource, id }) => {
      try {
        const { data: response } = await httpClient.get("/cms/league/lawyer");
        return { data: response };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    update: async ({
      variables,
    }: {
      id: string;
      resource: string;
      variables: ClubManagementCreateRequest;
    }) => {
      const url = "/cms/league/lawyer";
      const { content } = variables;

      const contentResult: any[] = [];
      (content ?? []).map((elem: any) => {
        // 12937: «Без медиа», неснятый тип без файла и пустая ссылка — всё это
        // блок без медиа. Иначе бэк получал media без url и падал на разборе.
        if (!elem.media?.type || elem.media.type === "NONE" || !elem.media?.url)
          elem.media = null;
        if (!elem.text && !elem.media) elem = null;
        if (elem) contentResult.push(elem);
      });
      try {
        const { data } = await httpClient.post(url, {
          ...variables,
          content: contentResult,
        });

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    create: async ({
      variables,
    }: {
      resource: string;
      variables: ClubManagementCreateRequest;
    }) => {
      const url = "/cms/league/lawyer";
      const { content } = variables;

      const contentResult: any[] = [];
      (content ?? []).map((elem: any) => {
        // 12937: «Без медиа», неснятый тип без файла и пустая ссылка — всё это
        // блок без медиа. Иначе бэк получал media без url и падал на разборе.
        if (!elem.media?.type || elem.media.type === "NONE" || !elem.media?.url)
          elem.media = null;
        if (!elem.text && !elem.media) elem = null;
        if (elem) contentResult.push(elem);
      });
      try {
        const { data } = await httpClient.post(url, {
          ...variables,
          content: contentResult,
        });

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
  };
